import getProfits from "@/public/graphQl/queries/getProfits";

export const getCollectingSettings = async ({dispatch, commit, rootGetters}, variables) => {
    let collectingData;

    const organizationId = rootGetters['app/getSelectedOrganization'].id;

    const params = {
        organizationId,
        ...variables,
    }

    try {
        commit('app/toggleLoading', null, {root: true});
        collectingData = await dispatch('app/request', {
            type: 'query',
            gql: getProfits,
            variables: params
        }, {root: true});
    } catch (error) {
        return error;
    } finally {
        commit('app/toggleLoading', null, {root: true});
    }

    if (collectingData.message) {
        throw collectingData.message;
    }

    if (collectingData.errors) {
        throw collectingData.errors;
    }

    const {
        data: {getCollectingSettings},
    } = collectingData;
    commit('setSettingsList', getCollectingSettings)
    // commit('setWebhooksTotal', getCollectingSettings)
    return getCollectingSettings;
};
